import React from 'react';
import PropTypes from 'prop-types';
import css from './Caret.css';
import MaterialIcon from '../SF/MaterialIcon';

export default class Caret extends React.Component {

  render() {
    return (
      <MaterialIcon
        className={css['icn-for-submenu']}
        onClick={this.props.onClick}
        aria-label={this.props.label}
        tabIndex="0"
        role="button"
        icon={this.props.down ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
        aria-expanded={!this.props.down}
      />
    );
  }
}

Caret.propTypes = {
  onClick: PropTypes.func.isRequired,
  down: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired 
};

Caret.defaultProps = {
  down: true,
  label: "Toggle options"
};
